import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../composables/useAuth.js'

import App from '../App.vue'
import CvCreatorWithPreview from '../CvCreatorWithPreview.vue'
import Login from '../components/Login.vue'
import Signup from '../components/Signup.vue'
import UserProfile from '../components/UserProfile.vue'
import Dashboard from '../components/Dashboard.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: App
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/cv-creator',
    name: 'CvCreator',
    component: CvCreatorWithPreview
  },
  {
    path: '/cv-creator/:id',
    name: 'CvEdit',
    component: CvCreatorWithPreview,
    props: route => ({ cvId: route.params.id })
  },
  // Legacy route for backwards compatibility
  {
    path: '/cv/create',
    name: 'CvCreate',
    redirect: '/cv-creator'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/profile',
    name: 'Profile',
    component: UserProfile,
    meta: { requiresAuth: true }
  },
  {
    path: '/password/new',
    name: 'ForgotPassword',
    component: () => import('../components/ForgotPassword.vue') // Lazy load
  },
  {
    path: '/password/edit',
    name: 'PasswordReset',
    component: () => import('../components/PasswordReset.vue') // Lazy load
  },
  {
    path: '/users/confirmation',
    name: 'EmailConfirmation',
    component: () => import('../components/SimpleEmailConfirmation.vue') // Updated to use the new simple version
  },
  {
    path: '/cv-creation-wizard',
    redirect: '/dashboard'
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../components/Pricing.vue')
  },
  {
    path: '/billing',
    name: 'Billing',
    redirect: () => {
      // Redirect to dashboard; billing is handled via Stripe portal from dropdown
      return { name: 'Dashboard' }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const { isAuthenticated, checkAuthStatus } = useAuth()
  await checkAuthStatus()

  if (to.name === 'Home' && isAuthenticated.value) {
    return { name: 'Dashboard' }
  }

  if (to.meta.requiresAuth && !isAuthenticated.value) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }
})

export default router